import React, { useState, useRef } from 'react'
import Tooltip from 'antd/es/tooltip'
import { getBEMCls } from '@/utils/classname'
import { useClickAway } from 'ahooks'
import { get } from '@/utils'

interface CascaderTooltipProps {
    list: any[]
    fieldNames: {
        key: string
        label: string
        value?: string // 填写value则返回指定的值 不填写返回全部
    }
    onItem: (item: any) => void
    contentNode?: React.ReactNode
}

// 及联选择器气泡单独抽离
const CascaderTooltip: React.FC<CascaderTooltipProps> = props => {
    const [visible, setVisible] = useState<boolean>(false)
    const getCls = (el?: string, moder?: string) => getBEMCls('search-input', el, moder)
    const tooltipRef = useRef(null)
    const containerRef = useRef(null)

    useClickAway(() => {
        visible && setVisible(false)
    }, [tooltipRef, containerRef])

    return (
        <Tooltip
            {...props}
            placement="bottomLeft"
            visible={visible}
            title={() =>
                props.list && (
                    <div ref={tooltipRef} className={getCls('word-con')}>
                        {props.list.map(item => (
                            <div
                                className={getCls('word')}
                                key={get(item, props.fieldNames.key)}
                                onClick={() => {
                                    setVisible(false)
                                    props.onItem &&
                                        props.onItem(props.fieldNames.value ? get(item, props.fieldNames.value) : item)
                                }}
                            >
                                {get(item, props.fieldNames.label)}
                            </div>
                        ))}
                    </div>
                )
            }
        >
            <div
                onClick={() => {
                    setVisible(true)
                }}
                ref={containerRef}
            >
                {props.children}
            </div>
        </Tooltip>
    )
}

export default CascaderTooltip
